import { SelectOption } from 'Components/Select/Select.types'

export const HUBSPOT_QUESTION_MODAL_REASON_OPTIONS: SelectOption[] = [
  {
    label: 'QuestionDeliveryTime',
    value: 'reason_1',
  },
  {
    label: 'QuestionReplacingDevice',
    value: 'reason_2',
  },
  {
    label: 'ILostMyDevice',
    value: 'reason_3',
  },
  {
    label: 'QuestionDeviceManagement',
    value: 'reason_4',
  },
  {
    label: 'PurchaseMyDevice',
    value: 'reason_5',
  },
  {
    label: 'TechnicalIssues',
    value: 'reason_6',
  },
  {
    label: 'ChangeOfDeliveryAddress',
    value: 'reason_7',
  },
  {
    label: 'Other',
    value: 'reason_8',
  },
]
